import { constants, Styles } from '@/styles';

export const styles: Styles = {
  marginBottom: constants.offset.xxlarge,
};
